import { useMemo, useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import CalenderTour from "./thememaker/Help/CalenderTour";
import ListingBoarding from "./thememaker/Help/Listingboarding"
import ClientPetTour from "./thememaker/Help/ClientPetTour";
import BoardingTour from "./thememaker/Help/ServiceTour";
import GroomingTour from "./thememaker/Help/GroomingserviceTour";
import RoomHelp from "./thememaker/Help/RoomTour";
import VetTour from "./thememaker/Help/VetTour";
import SupplierTour from "./thememaker/Help/SupplierTour";
import ProductTour from "./thememaker/Help/ProductTour";
import PurchasebillTour from "./thememaker/Help/PurchasebillTour";
import BusinessHoursDrawer from "../components/BusinessHoursDrawer/GroomingBusinessHoursDrawer";
import { useProfile } from "../context/ProfileContext";
import { HelpCircle } from "lucide-react";
import { Squares2X2Icon, ListBulletIcon } from "@heroicons/react/24/outline";
const PATH_LABELS = {
  admin: "Admin",
  dashboard: "Dashboard",
  grooming: "Grooming",
  addon_service: "Add-On Service",
  boarding: "Boarding",
  dog_walking: "Dog Walking",
  vet_clinic: "Vet Clinic",
  daycare: "Day Care",
  "admin/staff-management": "Staff Management",
  "admin/staff-management/employees": "Employees",
  "admin/clients-pets": "Clients & Pets",
  "admin/clients-pets/:id": "View Client",
  "booking-management": "Booking Management",
  boarding: "Boarding",
  grooming: "Grooming",
  daycare: "Day Care",
  "dog-walking": "Dog Walking",
  "vet-clinic": "Vet Clinic",
  "order-management": "Order Management",
  enquiry: "Enquiry",
  orders: "Orders",
  payments: "Payments",
  "expense-management": "Expense Management",
  expenses: "Expenses",
  reports: "Reports",
  standard: "Standard Reports",
  feedback: "Feedback",
  "reminderhistory": "Reminder History",

  settings: "Settings",
  "admin/settings/online_profile": "Profile Settings",
  online_profile: "Profile Settings",
  size_management: "Size Management",
  coat_management: "Coat Management",
  room_management: "Room Management",
  store_management: "Store Management",
  service_amenities: "Service Amenities",
  "admin/inventory-management/purchase_bills": "Purchase Bills",
  "admin/inventory-management/products": "Inventory/Products",
  "admin/inventory-management/suppliers": "Suppliers",
  "admin/booking-management": "Booking Management",
  
};

const NON_CLICKABLE = [
  "Inventory Management",
  "Service Management",
  "Booking Management",
  "Staff Management",
  "Order Management",
  "Expense Management",
  "Reports",
  "Settings",
];
 const HELP_ENABLED_PATHS = [
   "/admin/booking-management/listing",
   "/admin/booking-management/calendar",
   "/admin/clients-pets",
   "/admin/service-management/grooming",
   "/admin/service-management/boarding",
   "/admin/room_management",
   "/admin/service-management/vet_clinic",
   "/admin/inventory-management/suppliers",
   "/admin/inventory-management/products",
   "/admin/inventory-management/purchase_bills",
 ];

const FILTER_OPTIONS = {
  yesterday: "Yesterday",
  today: "Today",
  this_week: "This Week",
  this_month: "This Month",
  last_3_months: "Last 3 Months",
  last_6_months: "Last 6 Months",
  last_1_year: "Last 1 Year",
};

export const getDateRange = (filterKey) => {
  const today = new Date();
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  switch (filterKey) {
    case "yesterday": {
      const y = new Date(today);
      y.setDate(today.getDate() - 1);
      return { start: formatDate(y), end: formatDate(y) };
    }
    case "today":
      return { start: formatDate(today), end: formatDate(today) };
    case "this_week": {
      const day = today.getDay();
      const diff = today.getDate() - day + (day === 0 ? -6 : 1);
      const start = new Date(today);
      start.setDate(diff);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      return { start: formatDate(start), end: formatDate(end) };
    }
    case "this_month": {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      return { start: formatDate(first), end: formatDate(today) };
    }
    case "last_3_months": {
      const start = new Date(today);
      start.setMonth(today.getMonth() - 3);
      return { start: formatDate(start), end: formatDate(today) };
    }
    case "last_6_months": {
      const start = new Date(today);
      start.setMonth(today.getMonth() - 6);
      return { start: formatDate(start), end: formatDate(today) };
    }
    case "last_1_year": {
      const start = new Date(today);
      start.setFullYear(today.getFullYear() - 1);
      return { start: formatDate(start), end: formatDate(today) };
    }
    default:
      // fallback to today
      return { start: formatDate(today), end: formatDate(today) };
  }
};

const prettify = (segment) =>
  segment.replace(/[-_]/g, " ").replace(/\b\w/g, (ch) => ch.toUpperCase());

export const getLabelForSegment = (segment) => {
  if (!segment) return "";
  if (/^\d+$/.test(segment) || /^[0-9a-fA-F]{24}$/.test(segment))
    return "Details";
  return PATH_LABELS[segment] || prettify(segment);
};

const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { vendorId } = useProfile();
  const [showHelpTooltip, setShowHelpTooltip] = useState(false);
  const [activeHelp, setActiveHelp] = useState(null);
  const [isBusinessHoursOpen, setIsBusinessHoursOpen] = useState(false);
  const [fromGettingStarted, setFromGettingStarted] = useState(false);
  const [gettingStartedStepId, setGettingStartedStepId] = useState(null);

  const [activeFilter, setActiveFilter] = useState("yesterday");

  const showInfoIcon = HELP_ENABLED_PATHS.some((p) =>
    location.pathname.startsWith(p),
  );
  const { pathname, search } = location;

  const tab = useMemo(
    () => new URLSearchParams(search).get("tab"),
    [search]
  );

   const isBoardingActivityPage =
    pathname === "/admin/booking-management/boarding-activity";

    const currentBoardingView =
      new URLSearchParams(search).get("view") || "list";

    const handleBoardingViewChange = (viewKey) => {
      const params = new URLSearchParams(search);
      params.set("view", viewKey);
      navigate({ pathname, search: params.toString() });
    };

  const showBusinessHours = useMemo(() => {
    return (
      (
        pathname === "/admin/booking-management/calendar" &&
        (tab === "appointment" || tab === "vet")
      ) ||
      pathname === "/admin/booking-management/grooming-bookings" ||
      pathname === "/admin/booking-management/vet-bookings"
    );
  }, [pathname, tab]);

  const businessHoursType = useMemo(() => {
    if (pathname === "/admin/booking-management/vet-bookings") {
      return "Vet";
    }

    if (pathname === "/admin/booking-management/grooming-bookings") {
      return "Grooming";
    }

    return tab === "vet" ? "Vet" : "Grooming";
  }, [pathname, tab]);

  const pathnames = useMemo(
    () => location.pathname.split("/").filter(Boolean),
    [location.pathname],
  );

  const visibleItems = useMemo(() => {
    return pathnames.reduce((acc, seg, idx) => {
      const label = getLabelForSegment(seg);
      if (label === "Admin" || label === "Home") return acc;

      acc.push({
        segment: seg,
        label,
        idx,
        to: `/${pathnames.slice(0, idx + 1).join("/")}`,
      });
      return acc;
    }, []);
  }, [pathnames]);

  const handleInfoClick = () => {
    const path = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("type");
    const tab = searchParams.get("tab")?.toLowerCase();

    if (path === "/admin/booking-management/listing" && type === "boarding") {
      setActiveHelp("boarding-listing");
    } else if (
      path === "/admin/booking-management/calendar" &&
      tab === "boarding"
    ) {
      setActiveHelp("calender");
    } else if (path === "/admin/service-management/grooming") {
      setActiveHelp("grooming");
    } else if (path === "/admin/service-management/boarding") {
      setActiveHelp("service");
    } else if (path === "/admin/clients-pets") {
      setActiveHelp("client-pet");
    } else if (path === "/admin/room_management") {
      setActiveHelp("room-management");
    } else if (path === "/admin/service-management/vet_clinic") {
      setActiveHelp("vet");
    } else if (path === "/admin/inventory-management/suppliers") {
      setActiveHelp("supplier");
    } else if (path === "/admin/inventory-management/products") {
      setActiveHelp("product");
    } else if (path === "/admin/inventory-management/purchase_bills") {
      setActiveHelp("purchasebill");
    } else {
      // Default fallback
      alert("Help: No specific information for this page.");
    }
  };

  // Auto-open Business Hours drawer when navigated from GettingStarted
  // (same pattern as ClientPets.js openAddDrawer)
  useEffect(() => {
    if (location.state?.openBusinessHoursDrawer) {
      setIsBusinessHoursOpen(true);
      setFromGettingStarted(location.state?.fromGettingStarted || false);
      setGettingStartedStepId(location.state?.stepId || "businessHours");
      // Clear the state so it doesn't reopen on refresh
      navigate(location.pathname + location.search, {
        replace: true,
        state: {},
      });
    }
  }, [location.state, navigate]);

  useEffect(() => {
    if (!location.pathname.includes("/dashboard")) return;

    const params = new URLSearchParams(location.search);
    const currentStart = params.get("startDate");
    const currentEnd = params.get("endDate");

    // Helper to check if a given range matches a filter key
    const matchesFilter = (key) => {
      const range = getDateRange(key);
      return range.start === currentStart && range.end === currentEnd;
    };

    // Find which filter key (if any) matches the current URL dates
    let matchedKey = null;
    for (const key of Object.keys(FILTER_OPTIONS)) {
      if (matchesFilter(key)) {
        matchedKey = key;
        break;
      }
    }

        if (matchedKey) {
          // URL matches a known filter – set active filter accordingly
          setActiveFilter(matchedKey);
        } else {
          // No match → reset to "yesterday" (the default)
          const defaultRange = getDateRange("yesterday");
          const newParams = new URLSearchParams(location.search);
          newParams.set("filter", "yesterday");
          newParams.set("startDate", defaultRange.start);
          newParams.set("endDate", defaultRange.end);
          setActiveFilter("yesterday");
          navigate(
            { pathname: location.pathname, search: newParams.toString() },
            { replace: true },
          );
        }
  }, [location.pathname, location.search, navigate]);

  const handleBusinessHoursClick = () => {
    setIsBusinessHoursOpen(true);
  };

  // Called after business hours saved successfully
  const handleBusinessHoursSaved = () => {
    setIsBusinessHoursOpen(false);
    if (fromGettingStarted && gettingStartedStepId) {
      navigate("/admin/getting-started", {
        state: { stepCompleted: gettingStartedStepId },
      });
      setFromGettingStarted(false);
      setGettingStartedStepId(null);
    }
  };

  if (
    pathnames.length === 1 &&
    ["pos", "invoice", "calendar", "home"].includes(pathnames[0])
  )
    return <></>;
  const handleFilterChange = (filterKey) => {
    const range = getDateRange(filterKey);
    const params = new URLSearchParams(location.search);

    // Store the filter key along with start and end dates
    params.set("filter", filterKey);
    params.set("startDate", range.start);
    params.set("endDate", range.end);

    setActiveFilter(filterKey);
    navigate({ pathname: location.pathname, search: params.toString() });
  };

  return (
    <>
      <div className="flex flex-wrap items-center justify-between ml-4 mt-4 relative">
        <div className="flex flex-col">
          <nav aria-label="Breadcrumb" className="text-sm mb-3">
            <ol className="flex items-center flex-wrap gap-2">
              {visibleItems.map((item, idx) => {
                const { to, label } = item;
                const isLast = idx === visibleItems.length - 1;

                const isInsideSupplierRoute = pathnames.includes("suppliers");

                const isPurchaseBillCrumb =
                  label === "Purchase Bills" &&
                  pathnames.includes("purchase_bills") &&
                  isInsideSupplierRoute &&
                  pathnames[pathnames.length - 1] !== "purchase_bills";

                if (isPurchaseBillCrumb) {
                  const supplierId =
                    pathnames[pathnames.indexOf("suppliers") + 1];

                  return (
                    <li
                      key={to}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      {idx > 0 && <span className="text-gray-400">/</span>}
                      <span
                        onClick={() =>
                          navigate(
                            `/admin/inventory-management/suppliers/${supplierId}`,
                            { state: { openTab: "purchaseBill" } },
                          )
                        }
                        className="px-3 py-1 rounded-full border bg-white text-gray-700 border-gray-300 hover:bg-blue-50 cursor-pointer"
                      >
                        {label}
                      </span>
                    </li>
                  );
                }

                if (NON_CLICKABLE.includes(label)) {
                  return (
                    <li key={to} className="flex items-center gap-2">
                      {idx > 0 && <span className="text-gray-400">/</span>}
                      <span className="px-3 py-1 rounded-full border bg-white text-gray-700 border-gray-300">
                        {label}
                      </span>
                    </li>
                  );
                }

                return (
                  <li key={to} className="flex items-center gap-2">
                    {idx > 0 && <span className="text-gray-400">/</span>}

                    {isLast ? (
                      <span className="px-3 py-1 rounded-full bg-[#3C6CE7] text-white font-medium shadow-sm">
                        {label}
                      </span>
                    ) : (
                      <NavLink
                        to={to}
                        className="px-3 py-1 rounded-full border bg-white text-gray-700 border-gray-300 hover:bg-blue-50 transition-all"
                      >
                        {label}
                      </NavLink>
                    )}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>

        <div className="flex items-center gap-6 mr-6">
          {isBoardingActivityPage && (
            <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-0.5">
              <button
                onClick={() => handleBoardingViewChange("list")}
                className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold rounded-md transition-colors ${
                  currentBoardingView === "list"
                    ? "bg-white shadow-sm text-slate-800"
                    : "text-slate-500"
                }`}
              >
                <ListBulletIcon className="w-4 h-4" /> list
              </button>
              <button
                onClick={() => handleBoardingViewChange("table")}
                className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold rounded-md transition-colors ${
                  currentBoardingView === "table"
                    ? "bg-white shadow-sm text-blue-600 ring-1 ring-blue-200"
                    : "text-slate-500"
                }`}
              >
                <Squares2X2Icon className="w-4 h-4" /> table
              </button>
            </div>
          )}
          {showBusinessHours && (
            <button
              onClick={handleBusinessHoursClick}
              className="flex items-center gap-3 px-4 py-2 text-base font-semibold text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded-lg transition-all cursor-pointer bg-transparent"
            >
              <Clock className="w-5 h-5" />
              Set Business Hours
            </button>
          )}
          {showInfoIcon && (
            <div
              className="relative ml-auto mr-4"
              onMouseEnter={() => setShowHelpTooltip(true)}
              onMouseLeave={() => setShowHelpTooltip(false)}
            >
              <HelpCircle
                className="w-7 h-7 text-gray-600 cursor-pointer hover:text-blue-600"
                onClick={handleInfoClick}
              />

              {showHelpTooltip && (
                <div className="absolute right-0 top-full mt-2 w-auto bg-black text-white text-xs rounded-md px-3 py-2 shadow-lg whitespace-nowrap pointer-events-none z-10">
                  help
                </div>
              )}
            </div>
          )}
        </div>
        {/* --- NEW: Dashboard Date Range Filter --- */}
        {pathnames.includes("dashboard") && (
          <div className="flex flex-wrap items-center gap-2 mt-1 mb-2">
            <span className="text-sm font-medium text-slate-600 mr-1">
              Date Range:
            </span>
            {Object.entries(FILTER_OPTIONS).map(([key, label]) => (
              <button
                key={key}
                onClick={() => handleFilterChange(key)}
                className={`px-4 py-1.5 text-xs font-medium rounded-full border transition-all duration-200 ${
                  activeFilter === key
                    ? "bg-indigo-600 text-white border-indigo-600 shadow-sm"
                    : "bg-white text-slate-600 border-slate-200 hover:bg-slate-100 hover:text-slate-800"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        )}
      </div>
      {activeHelp === "boarding-listing" && (
        <ListingBoarding onClose={() => setActiveHelp(null)} />
      )}
      {activeHelp === "calender" && (
        <CalenderTour onClose={() => setActiveHelp(null)} />
      )}
      {activeHelp === "client-pet" && (
        <ClientPetTour onClose={() => setActiveHelp(null)} />
      )}
      {activeHelp === "service" && (
        <BoardingTour onClose={() => setActiveHelp(null)} />
      )}
      {activeHelp === "grooming" && (
        <GroomingTour onClose={() => setActiveHelp(null)} />
      )}

      {activeHelp === "room-management" && (
        <RoomHelp onClose={() => setActiveHelp(null)} />
      )}
      {activeHelp === "vet" && <VetTour onClose={() => setActiveHelp(null)} />}
      {activeHelp === "supplier" && (
        <SupplierTour onClose={() => setActiveHelp(null)} />
      )}
      {activeHelp === "product" && (
        <ProductTour onClose={() => setActiveHelp(null)} />
      )}
      {activeHelp === "purchasebill" && (
        <PurchasebillTour onClose={() => setActiveHelp(null)} />
      )}

      <BusinessHoursDrawer
        isOpen={isBusinessHoursOpen}
        onClose={() => setIsBusinessHoursOpen(false)}
        onSave={handleBusinessHoursSaved}
        type={businessHoursType}
        vendorId={vendorId}
      />
    </>
  );
};;

export default Breadcrumbs;